import useQuery, { QueryOptions } from 'hooks/useQuery';
import {
  getOrganizations,
  getOrganizationsReset,
} from 'store/organizations/actions';
import { getOrganizationsSelector as selector } from 'store/organizations/selectors';

const useOrganizations = (params: QueryOptions) =>
  useQuery({
    action: getOrganizations,
    resetAction: getOrganizationsReset,
    selector,
    ...params,
  });

export default useOrganizations;
